import { IMRErrorsSummaryController } from "./errors-summary.controller"
import { ERRORS_SUMMARY_SERVICE_NAME } from './services'

//#region Asset Imports

import './errors-summary.scss'
import * as TEMPLATE from './errors-summary.tpl.html'

//#endregion

export const COMPONENT_NAME: string = 'imrErrorsSummary'

export class IMRErrorsSummaryComponent implements ng.IComponentOptions {

    controller = [ERRORS_SUMMARY_SERVICE_NAME, IMRErrorsSummaryController]

    bindings = {
        options: '<'
    } as { [index: string]: string }

    template = TEMPLATE

}